import React from "react";

export default function TypingIndicator({ name = "kimbocorp admin" }) {
  return (
    <div className="messageListOuter chatTypingMessage" role="status" aria-label={`${name} is typing`}>
      <div className="messageListInner">
        <div
          className="profile_photo"
          style={{ backgroundImage: "url(assets/img/Frame1.svg)" }}
        />
        <div className="messagebyUser">
          <div className="userName">
            <div className="userMessage">
              <h4>
                <span>{name}</span>
              </h4>
              <div className="messagingService chatTypingBubble">
                <span className="chatTypingDots" aria-hidden="true">
                  <span />
                  <span />
                  <span />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
